import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { IButton, TranslateService } from '@devinforius/i-essentials';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { ConfirmationService } from 'primeng/api';
import { DetailSplit, Page, Scan as ScanDTO, ScanSplitMode, Split } from 'src/app/shared/models/iScanAPI/scan';
import { IScanAPIService } from 'src/app/shared/services/iscan.service';
import { getButtonsTitle, getQuickButtonsIScan } from './details-scan-config';
import * as async from 'async';
import { catchError, forkJoin, of } from 'rxjs';
import { ServicesService } from 'src/app/shared/services/services.service';
import { SourcesService } from 'src/app/shared/services/sources.service';
import { UsersService } from 'src/app/shared/services/users.service';
import { ClassificationsService } from 'src/app/shared/services/classifications.service';
import { QrCodeExplodeRegexpFull } from 'src/app/_pipes/qrCode.pipe';
import { GlobalCentreNumerisationDTO } from 'src/app/shared/models/iCourrier/centre-numerisation/global-centre-numerisation';
import { BinderClassificationDtoV2, DropdownService, SourceDto } from 'src/app/shared/interfaces';
import { UserDto } from 'src/app/shared/interfaces/users';
import saveAs from 'file-saver';
import { Title } from '@angular/platform-browser';
import { MailsMeSearchParams } from 'src/app/shared/models/mails/mails-me-search';
import { UserInfo } from 'src/app/shared/models/iCourrier/me/user-info';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MailsSearchFromBroadcast } from 'src/app/shared/models/mails/mails-search';
import { ICourrierScanService } from 'src/app/shared/services/iCourrier-scan.service';
import { ScanFromCourrier } from 'src/app/shared/models/iCourrier/scans/scan-from-courrier';
import moment from 'moment';
import { MailsService } from 'src/app/shared/services/mails.service';
import { MeService } from 'src/app/shared/services/me.service';
import { ScanSearchMailsDTO } from 'src/app/shared/interfaces/scans/scan-search-mail-dto.interface';
import { NumerisationCentersService } from 'src/app/shared/services/numerisation_centers.service';
import { MeRightMailGlobal } from 'src/app/shared/models/iCourrier/me/right-mail-global';
import { MassEncodeDisplayedDatas } from 'src/app/shared/interfaces/scans/mass-encode-datas';
import { ScanSearchMailsForBatchAttachment } from 'src/app/shared/models/iCourrier/scans/scan-search-mails';
import { Scan, ScanPage, ScanSplit } from '@devinforius/i-scan';
import { ScanSplitButton } from '@devinforius/i-scan/lib/interfaces';
@Component({
  selector: 'app-details-scan',
  templateUrl: './details-scan.component.html',
  styleUrls: ['./details-scan.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class DetailsScanComponent implements OnInit, OnDestroy {
  public loader = false;
  public spinnerCountSave = 0;
  public spinnerCountTotal = 0;
  public infosCard: DetailSplit;
  public modifyDetailSplitGuid: string;
  public openEditDescription = false;
  public guid: string;
  public originScan: ScanDTO; // Scan from backend
  public originScanInfosiCourrier: ScanFromCourrier;
  public scan: Scan; // Scan from backend modified by frontend (mapped)
  public buttonTitle: IButton[];
  public buttonsAction: ScanSplitButton[];

  public expressionReguliereFull = /<([^>]+)>(.*?)<\/\1>/g;
  public expressionReguliereWithiCourrierID = new RegExp('ECOURRIER(\\s|.)*\\*ID > (\\d*)(\\s|.)*');

  public listOfServices: DropdownService[] = [];
  public listOfSources: SourceDto[] = [];
  public listOfRecipients: UserDto[] = [];
  public listOfClassification: BinderClassificationDtoV2[] = [];
  public listOfCenterNums: GlobalCentreNumerisationDTO[] = [];
  public showAllServices = null;

  public userInfo: UserInfo;
  public chosenScanSplit: ScanSplit;

  public modalParams = {
    isDraggable: false,
    isResizable: true,
    isModal: true,
    style: { height: '80vh', width: '50vw', minWidth: '50vw', maxWidth: '50vw' },
  };

  public openModalCreateMailFile = false;
  public modalHeaderCreateMailFile = {
    title: 'iScan.action.createAMailFile',
    iconTitle: 'bi bi-plus-circle',
    showNotification: false,
    showParameters: false,
    closable: true,
  };
  public modalParamsCreateMailFile = {
    isDraggable: false,
    isResizable: true,
    isModal: true,
    style: { height: '20rem', width: '50vw', minWidth: '50vw', maxWidth: '50vw' },
  };

  public openFastMailCreationModal = false;
  public modalHeaderFastCreation = {
    basicTitle: 'iScan.action.createAMAilToBeCompleted',
    title: '',
    showNotification: false,
    showParameters: false,
    closable: false,
  };
  public modalParamsFastMailCreationModal = {
    isDraggable: false,
    isResizable: true,
    isModal: true,
    style: { width: '50vw', minWidth: '50vw', maxWidth: '50vw' },
  };

  public openDuplicationModal = false;
  public modalHeaderDuplicate = {
    basicTitle: 'iScan.action.duplicateAMail',
    title: '',
    showNotification: false,
    showParameters: false,
    closable: true,
  };
  public modalParamsDuplicate = {
    isDraggable: false,
    isResizable: true,
    isModal: true,
    style: { height: '20rem', width: '50vw', minWidth: '50vw', maxWidth: '50vw' },
  };
  public attachForm: FormGroup = new FormGroup({
    linkMailId: new FormControl(null, Validators.required),
    duplicateRecipients: new FormControl(false),
    duplicateActions: new FormControl(false),
  });
  public listOfRecentMails: { label: string; value: number }[];

  public openAttachmentModal = false;
  public modalHeaderAttachment = {
    basicTitle: 'iScan.action.attachToAMail',
    title: '',
    showNotification: false,
    showParameters: false,
    closable: true,
  };

  public openProcessAllModal: boolean = false;
  public modalHeaderProcessAll = {
    title: 'iScan.action.processAll',
    showNotification: false,
    showParameters: false,
    closable: true,
  };
  public modalParamsProcessAll = {
    isDraggable: false,
    isResizable: true,
    isModal: true,
    style: { height: '80vh', width: '70vw', minWidth: '50vw', maxWidth: '70vw' },
  };

  public openAttachAllModal: boolean = false;
  public modalHeaderAttachAll = {
    title: 'iScan.action.attachAll',
    showNotification: false,
    showParameters: false,
    closable: true,
  };
  public modalParamsAttachAll = {
    isDraggable: false,
    isResizable: true,
    isModal: true,
    style: { height: '80vh', width: '70vw', minWidth: '50vw', maxWidth: '70vw' },
  };

  private channel: BroadcastChannel;

  constructor(
    public router: Router,
    public route: ActivatedRoute,
    private toastr: ToastrService,
    private iScanAPIService: IScanAPIService,
    private confirmationService: ConfirmationService,
    private translate: TranslateService,
    public spinner: NgxSpinnerService,
    private titleService: Title,
    public servicesService: ServicesService,
    public sourcesService: SourcesService,
    public usersService: UsersService,
    public classificationService: ClassificationsService,
    private iCourrierScanService: ICourrierScanService,
    private mailsService: MailsService,
    private meService: MeService,
    private numerisationCentersService: NumerisationCentersService
  ) { }

  ngOnInit(): void {
    this.getTranslationsAndButtons();

    //ouverture d'un BroadcastChannel pour lier les onglets entre eux lors de la création d'un nouveau courrier (qui se fera dans un nouvel onglet) afin que les données soient transmises entre ces deux onglets
    this.channel = new BroadcastChannel('courrierCreatedForiScanChannel');
    this.channel.addEventListener('message', (e) => {
      if (e.data.messageId === 'mailCreated') {
        this.displayAndSaveScanDetails(e.data, true);
      }
    });

    this.guid = this.route.snapshot.params['id'];

    if (this.guid) {
      const scanInfos: { fromiScan: ScanDTO; fromiCourrier: ScanFromCourrier } = { fromiScan: null, fromiCourrier: null };
      forkJoin({
        iScanData: this.iScanAPIService.getIscanData(this.guid).pipe(
          catchError(() => {
            this.toastr.error(this.translate.translate('iScan.error.errorRetrievingScan'));
            return of(null);
          })
        ),
        scansLots: this.iCourrierScanService.getScanLots({ LotGuids: this.guid }).pipe(
          catchError(() => {
            this.toastr.error(this.translate.translate('iScan.error.errorRetrievingScanLots'));
            return of(null);
          })
        ),
      }).subscribe({
        next: (res) => {
          scanInfos.fromiScan = res.iScanData;
          scanInfos.fromiCourrier = res.scansLots.items.find((scan) => scan.guid === this.guid);
          this.getQrCodeDatas(scanInfos);
        },
      });
    }
  }

  ngOnDestroy(): void {
    this.channel.close();
  }

  getTranslationsAndButtons(): void {
    this.titleService.setTitle(this.translate.translate('tabsTitle.iScan'));
    this.modalHeaderCreateMailFile.title = this.translate.translate(this.modalHeaderCreateMailFile.title);
    this.modalHeaderFastCreation.basicTitle = this.translate.translate(this.modalHeaderFastCreation.basicTitle);
    this.modalHeaderDuplicate.basicTitle = this.translate.translate(this.modalHeaderDuplicate.basicTitle);
    this.modalHeaderAttachment.basicTitle = this.translate.translate(this.modalHeaderAttachment.basicTitle);
    this.modalHeaderProcessAll.title = this.translate.translate(this.modalHeaderProcessAll.title);
    this.modalHeaderAttachAll.title = this.translate.translate(this.modalHeaderAttachAll.title);
    this.buttonsAction = getQuickButtonsIScan(this.translate);
    this.buttonTitle = getButtonsTitle(this, this.translate);
  }

  getQrCodeDatas(fullDatas: { fromiScan: ScanDTO; fromiCourrier: ScanFromCourrier }): void {
    this.originScan = fullDatas.fromiScan;
    this.originScanInfosiCourrier = fullDatas.fromiCourrier;

    const scan = new Scan();
    scan.guid = this.originScan.guid;
    scan.name = this.originScan.name;
    scan.nbrPages = this.originScan.numPages;
    scan.splitmode = this.originScan.splitMode;

    // Avant toute chose, il va falloir faire la récupération des informations pour l'affichage des QRcodes
    // En effet, pour un type de QRCode précis, iCourrier va avoir besoin de faire 6 requêtes différentes
    // Ce que l'on va faire c'est récupérer les ids précises demandées par les QRcodes, afin de réduire au maximum les temps de requêtes
    const listOfServicesIds: number[] = [];
    const listOfSourcesIds: number[] = [];
    const listOfRecipientsIds: number[] = [];
    const listOfClassificationIds: number[] = [];
    const listOfCenterNums: string[] = [];

    // Map pour récupérer les données des !== qrcodes afin de faire les requêtes adaptées en ids
    async.eachSeries(
      this.originScan.splits,
      (split, nextSplit) => {
        const foundQRCode = split.mainCode;
        if (foundQRCode) {
          if (this.expressionReguliereFull.test(foundQRCode)) {
            // Si le qrCode correspond a cette expression régulière cela veut dire qu'on va pouvoir récupérer des ids pour plus tard
            const results = [];
            // En premier lieu, on va récupérer toutes les valeurs correspondants à la RegExp
            const valuesOfTheREGEXP = foundQRCode.match(this.expressionReguliereFull);

            // Puis, pour chaque occurrence, on va extraire la balise et son contenu
            if (valuesOfTheREGEXP?.length > 0) {
              valuesOfTheREGEXP.forEach((item: string) => {
                const arr = item.split(/<([^>]+)>/);
                results.push({ balise: arr[1], contenu: arr[2] });
              });

              // Enfin, pour chaque balise/contenu, on va chercher la valeur
              results.find((x) => x.balise === 'SVCID')?.contenu ? listOfServicesIds.push(+results.find((x) => x.balise === 'SVCID').contenu) : null;
              results.find((x) => x.balise === 'SRCID')?.contenu ? listOfSourcesIds.push(+results.find((x) => x.balise === 'SRCID').contenu) : null;
              results.find((x) => x.balise === 'DESTCNTID')?.contenu
                ? listOfRecipientsIds.push(+results.find((x) => x.balise === 'DESTCNTID').contenu)
                : null;
              results.find((x) => x.balise === 'CODECLASSID')?.contenu
                ? listOfClassificationIds.push(+results.find((x) => x.balise === 'CODECLASSID').contenu)
                : null;
              results.find((x) => x.balise === 'CENTERNUM')?.contenu
                ? listOfCenterNums.push(results.find((x) => x.balise === 'CENTERNUM').contenu)
                : null;
              nextSplit();
            } else {
              nextSplit();
            }
          } else {
            // S'il ne correspond pas, cela ne sert a rien d'aller plus loin avec ce QRCode, on passe a la suite
            nextSplit();
          }
        } else {
          nextSplit();
        }
      },
      () => {
        this.getBasicRequestsQRCode(scan, listOfServicesIds, listOfSourcesIds, listOfRecipientsIds, listOfClassificationIds, listOfCenterNums);
      }
    );
  }

  private getBasicRequestsQRCode(
    scan,
    listOfServicesIds: number[],
    listOfSourcesIds: number[],
    listOfRecipientsIds: number[],
    listOfClassificationIds: number[],
    listOfCenterNums: string[]
  ): void {
    forkJoin({
      listOfNumerisations: listOfCenterNums?.length > 0 ? this.numerisationCentersService.getGlobalCentreNumerisation() : of([]),

      // TODO envoyer la liste d'ids pour les services
      services: listOfServicesIds?.length > 0 ? this.servicesService.fetchMappedServicesToPrimeNGDropdowns() : of([]),

      sources: listOfSourcesIds?.length > 0 ? this.sourcesService.fetchSources(listOfSourcesIds) : of([]),

      recipients: listOfRecipientsIds?.length > 0 ? this.usersService.fetchUsersFromiAdmin({ ContactIds: listOfRecipientsIds.join(',') }) : of([]),

      // TODO envoyer la liste d'ids pour les codes de classements
      classificationCodes: listOfClassificationIds?.length > 0 ? this.classificationService.fetchFoldersClassificationV2() : of([]),

      // On le fait toujours car on en aura besoin dans la modale d'encodage en masse, alors autant ne pas devoir la rappeler
      meRightMails: this.meService.rightMailGlobal(),
    }).subscribe({
      next: (res: {
        listOfNumerisations: GlobalCentreNumerisationDTO[];
        services: DropdownService[];
        sources: SourceDto[];
        recipients: UserDto[];
        classificationCodes: BinderClassificationDtoV2[];
        meRightMails: MeRightMailGlobal;
      }) => {
        this.listOfCenterNums = res.listOfNumerisations;
        this.listOfServices = res.services;
        this.listOfSources = res.sources;
        this.listOfRecipients = res.recipients;
        this.listOfClassification = res.classificationCodes;
        this.showAllServices = !res.meRightMails.iScan.limitFirstLevelService;

        // Une fois toutes ces données récupérées, on peut continuer le mapping
        const splitBlobRequests = this.originScan.splits.map((split: Split, index) => ({
          guid: split.guid,
          name: this.insertIndexIntoFilename(split.name, index + 1),
          lock: split.lock,
          metadata: null,
          mainCode: split.mainCode,
          details: this.setDetailsSplits(split),
          pages: split.pages.map((page: Page) => ({
            ...page,
            blob: page.url,
          })),
        }));
        const trashBlobRequests = this.originScan.pagesDeleted.map((page: Page) => ({
          ...page,
          blob: page.url,
        }));
        const tmpScan = scan;
        tmpScan.splits = splitBlobRequests as unknown as ScanSplit[];
        tmpScan.trash = trashBlobRequests as unknown as ScanPage[];
        this.scan = tmpScan;
      },
    });
  }

  insertIndexIntoFilename(filename: string, index: number): string {
    const dotIndex = filename.lastIndexOf('.');
    if (dotIndex === -1) {
      return `${filename}-${index}`;
    }
    const name = filename.substring(0, dotIndex);
    const extension = filename.substring(dotIndex);
    return `${name}-${index}${extension}`;
  }

  setDetailsSplits(scanSplit: Split): DetailSplit {
    const splitiScanIndex = this.originScan.splits.findIndex((split) => split.guid === scanSplit.guid);
    const metaData = this.originScan.splits[splitiScanIndex]?.mainCode;

    const splitiCourrierIndex = this.originScanInfosiCourrier.splits.findIndex((split) => split.split === scanSplit.guid);

    let details = {
      title: null,
      description: null,
      titleButton: null,
    };

    // D'abord on regarde s'il y a un lien avec un courrier
    if (splitiCourrierIndex >= 0) {
      const mailObject = this.originScanInfosiCourrier.splits[splitiCourrierIndex].courrierObjet
        ? this.originScanInfosiCourrier.splits[splitiCourrierIndex].courrierObjet
        : this.translate.translate('courrier.mailWithoutObject');
      details = {
        title: this.translate.translate('global.mail'),
        description: mailObject,
        titleButton: this.originScanInfosiCourrier.splits[splitiCourrierIndex].courrierId,
      };
    }
    // Une fois ici, on doit vérifier s'il y a un QRCode et son type
    else if (metaData) {
      // S'il y a un QRCode alors on va regarder son type
      if (this.expressionReguliereWithiCourrierID.test(metaData.toUpperCase())) {
        const id = metaData.toUpperCase().replace(this.expressionReguliereWithiCourrierID, '$2');
        details = {
          title: 'QR code avec ID Courrier',
          description: 'ID Courrier : ' + id,
          titleButton: null,
        };
      } else if (this.expressionReguliereFull.test(metaData)) {
        const qrCodeExplode = new QrCodeExplodeRegexpFull();
        const qrCodeTransformed = qrCodeExplode.transform(
          metaData,
          this.expressionReguliereFull,
          this.listOfCenterNums,
          this.listOfServices,
          this.listOfSources,
          this.listOfRecipients,
          this.listOfClassification,
          this.showAllServices
        );
        details = {
          title: 'QR code',
          description: qrCodeTransformed,
          titleButton: null,
        };
      } else {
        details = {
          title: 'Error',
          description: 'QRCode non reconnu',
          titleButton: null,
        };
      }
    } else {
      // S'il n'y a pas de QRCode c'est simple
      details = {
        title: 'Error',
        description: this.originScan.splitMode === ScanSplitMode.None ? 'Séparation manuelle : Aucune information récupérée' : 'Aucun QRCode détecté',
        titleButton: null,
      };
    }
    return details;
  }

  onScanSplitActionClick(event: { scanSplit: ScanSplit; action: string }): void {
    const index = this.scan.splits.findIndex((split) => split.guid === event.scanSplit.guid);
    switch (event.action) {
      case 'createAMailFile':
        if (!event.scanSplit.lock) {
          this.chosenScanSplit = event.scanSplit;
          console.log(event);
          this.openModalCreateMailFile = true;
        } else {
          const indexiCourrier = this.originScanInfosiCourrier.splits.findIndex((split) => split.split === event.scanSplit.guid);
          if (indexiCourrier > -1) {
            this.toastr.error(
              this.translate.translate('iScan.warning.aMailFileAlreadyCreatedOnThisScan', {
                mailId: this.originScanInfosiCourrier.splits[indexiCourrier].courrierId,
              })
            );
          } else {
            this.toastr.error(this.translate.translate('iScan.warning.aMailFileAlreadyCreatedOnThisScanNoId'));
          }
        }
        break;
      case 'scrollFile':
        this.scroll(event.scanSplit.pages[0].guid, index);
        break;
      case 'downloadFile':
        this.downloadFile(this.guid, event.scanSplit);
        break;
    }
  }

  scroll(id: string, i: number, nocolor?: boolean): void {
    const el = document.getElementById('file_' + i);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    const el1 = document.getElementById(id + '_images');
    if (el1 && !nocolor) {
      el1.style.transition = 'background-color 0.1s ease-in';
      el1.style.setProperty('background-color', '#DB952520', 'important');
      setTimeout(() => {
        el1.style.transition = 'background-color 0.8s ease-out';
        el1.style.backgroundColor = '';
      }, 700);
    }
  }

  downloadFile(fileGuid: string, split: ScanSplit): void {
    this.iScanAPIService.saveSplit(this.scan.guid, this.scan.splits).subscribe({
      next: () => {
        this.iScanAPIService.downloadSplit(fileGuid, split.guid).subscribe({
          next: (res) => {
            const downloadURL = URL.createObjectURL(res);
            saveAs(downloadURL, split.name);
            this.toastr.success(this.translate.translate('iScan.success.download'));
          },
          error: () => {
            this.toastr.error(this.translate.translate('iScan.error.download'));
          },
        });
      },
    });
  }

  quitButton(): void {
    this.confirmationService.confirm({
      message: this.translate.translate('iScan.information.leavePage'),
      key: 'confirmDialogDetailsScan',
      accept: () => {
        if (this.scan) {
          this.iScanAPIService.saveSplit(this.scan.guid, this.scan.splits).subscribe({
            next: () => {
              this.router.navigate(['private/ic/home-scans']);
            },
          });
        } else this.router.navigate(['private/ic/home-scans']);
      },
    });
  }

  public onChooseActionModal(typeOfActionChosen: 'newMailToBeCompleted' | 'newMailComplete' | 'duplicateMail' | 'attachToAMail'): void {
    if (typeOfActionChosen === 'newMailToBeCompleted') {
      this.openModalCreateMailFile = false;
      this.modalHeaderFastCreation.title = this.modalHeaderFastCreation.basicTitle + ' - ' + this.chosenScanSplit.name;
      this.openFastMailCreationModal = true;
    } else if (typeOfActionChosen === 'newMailComplete') {
      this.openModalCreateMailFile = false;
      this.openNewMailInNewTab('/newCourrier');
    } else if (typeOfActionChosen === 'duplicateMail') {
      this.openModalCreateMailFile = false;
      this.modalHeaderDuplicate.title = this.modalHeaderDuplicate.basicTitle + ' - ' + this.chosenScanSplit.name;
      this.setDataForDuplication();
    } else if (typeOfActionChosen === 'attachToAMail') {
      this.openModalCreateMailFile = false;
      this.modalHeaderAttachment.title = this.modalHeaderAttachment.basicTitle + ' - ' + this.chosenScanSplit.name;
      this.openAttachmentModal = true;
    }
  }

  private openNewMailInNewTab(typeOfQuery: string, duplicateRecipients: boolean = undefined, duplicateActions: boolean = undefined): void {
    // En premier lieu on envoie la sauvegarde des infos au backend iScan
    this.iScanAPIService.saveSplit(this.scan.guid, this.scan.splits).subscribe({
      next: () => {
        // Le scan est terminé lorsque TOUS les splits sont lock === true SAUF celui sur lequel on a cliqué
        const isScanFinished = this.scan.splits.filter((split) => split.guid !== this.chosenScanSplit.guid).every((split) => split.lock);

        // Ensuite on doit absolument récupérer les infos du QRCode, si celui-ci est utilisable pour patcher un nouveau courrier
        // Si le titre est 'QR code' ca veut dire qu'on a un QRcode avec les infos dont on aura besoin pour patcher un nouveau courrier
        let stringToAppend = '';
        if (this.chosenScanSplit.details?.title === 'QR code') {
          const index = this.originScan.splits.findIndex((split) => split.guid === this.chosenScanSplit.guid);
          const metaData = this.originScan.splits[index]?.mainCode;
          const arrayOfBalisesAndContent = [];
          const values = metaData.match(this.expressionReguliereFull);

          // Puis, pour chaque occurrence, on va extraire la balise et son contenu
          if (values?.length > 0) {
            values.forEach((item: string) => {
              const arr = item.split(/<([^>]+)>/);
              arrayOfBalisesAndContent.push({ balise: arr[1], content: arr[2] });
            });
          }
          // Une fois les balises et contenus obtenus, on va créer le string à ajouter au routing
          // En premier lieu, si on a un centre de numérisation, on va récupérer son id. En effet, de base il s'agit du codeQR qui est indiqué (celui-ci est unique, a ce jour : 10/04/25)
          arrayOfBalisesAndContent.map((item) => {
            if (item.balise === 'CENTERNUM') {
              item.content = this.listOfCenterNums.find((centerNum) => centerNum.codeQr === item.content)?.id;
              return item;
            } else return item;
          });
          stringToAppend = arrayOfBalisesAndContent.map((item) => `&${item.balise.toLowerCase()}=${item.content}`).join('');
        }
        if (duplicateRecipients !== undefined) {
          stringToAppend = stringToAppend + '&duplicateRecipients=' + duplicateRecipients;
        }
        if (duplicateActions !== undefined) {
          stringToAppend = stringToAppend + '&duplicateActions=' + duplicateActions;
        }
        window.open(
          '/private/ic/newSc/' +
          this.originScan.guid +
          typeOfQuery +
          '?finished=' +
          isScanFinished +
          '&description=' +
          this.chosenScanSplit.name +
          '&splitGuid=' +
          this.chosenScanSplit.guid +
          stringToAppend,
          '_blank'
        );
      },
    });
  }

  private setDataForDuplication(): void {
    this.openDuplicationModal = true;
    this.listOfRecentMails = [];
    this.meService.getUserInfo().subscribe({
      next: (response) => {
        this.userInfo = response;
        const params: MailsMeSearchParams = {
          SortOrder: 'DESC',
          SortFields: 'ID',
          PageSize: 50,
          CreatedByUserId: this.userInfo.id,
          CalcTotal: false,
        };
        this.mailsService.getAllMails(params).subscribe({
          next: (res) => {
            this.listOfRecentMails = res.items.map((x) => {
              return { label: x.id + ' - ' + x.objet, value: x.id };
            });
          },
        });
      },
    });
  }

  public submitAttachForm(): void {
    this.openNewMailInNewTab(
      '/duplicateRecent/' + this.attachForm.value.linkMailId,
      this.attachForm.value.duplicateRecipients,
      this.attachForm.value.duplicateActions
    );
    this.attachForm.patchValue({ linkMailId: null, duplicateRecipients: false, duplicateActions: false });
    this.openDuplicationModal = false;
  }

  public clickDetailsCard(event: ScanSplit): void {
    window.open('/private/ic/tabs/' + event.details.titleButton, '_blank');
  }

  public closingModalSimpleMailCreation(mailCreatedWithRights: ScanSearchMailsDTO): void {
    if (mailCreatedWithRights) {
      this.displayAndSaveScanDetails(mailCreatedWithRights).then(() => {
        this.openFastMailCreationModal = false;
      });
    } else this.openFastMailCreationModal = false;
  }

  public closingAttachmentModal(mailCreatedWithRights: ScanSearchMailsDTO): void {
    if (mailCreatedWithRights) {
      this.displayAndSaveScanDetails(mailCreatedWithRights).then(() => {
        this.openAttachmentModal = false;
      });
    } else this.openAttachmentModal = false;
  }

  /*
    be careful about this one compared to closingAttachmentModal because we don't have a chosenScanSplit so we can't call the same method :) 
  */
  public closingAttachAllModal(mailCreatedWithRights: ScanSearchMailsForBatchAttachment[]): void {
    if (mailCreatedWithRights?.length) {
      mailCreatedWithRights.forEach((mail) => {
        const objectOfMail = mail.objet ? mail.objet : this.translate.translate('courrier.mailWithoutObject');
        const foundScanSplit = this.scan.splits.find((split) => split.guid === mail.splitGuid);
        foundScanSplit.details = {
          title: this.translate.translate('global.mail'),
          description: mail.canViewMail ? objectOfMail : this.translate.translate('iScan.error.noRightsToSeeTheDescription'),
          titleButton: mail.id.toString(),
        };
      });
      this.openAttachAllModal = false;
    } else this.openAttachmentModal = false;
    this.spinner.hide();
  }

  /*
    @params mailCreatedWithRights: ScanSearchMailsDTO | MailsSearchFromBroadcast
    @paramsDetails : ScanSearchMailsDTO when you come directly from a modal
    @paramsDetails : MailsSearchFromBroadcast when you come from the Broadcast channel
  */
  displayAndSaveScanDetails(mailCreatedWithRights: ScanSearchMailsDTO | MailsSearchFromBroadcast, fromBroadcast = false): Promise<boolean> {
    return new Promise((resolve) => {
      let foundScanSplit;
      if (!fromBroadcast) {
        // then mailCreatedWithRights === ScanSearchMailsDTO
        foundScanSplit = this.scan.splits.find((split) => split.guid === this.chosenScanSplit.guid);
      } else {
        if ((mailCreatedWithRights as MailsSearchFromBroadcast).scanLotCompleted) {
          this.toastr.success(this.translate.translate('iScan.information.scanCompleted'), this.translate.translate('iScan.success.success'));
          this.router.navigateByUrl('private/ic/home-scans');
        } else {
          // then mailCreatedWithRights === MailsSearchFromBroadcast
          foundScanSplit = this.scan.splits.find((split) => split.guid === (mailCreatedWithRights as MailsSearchFromBroadcast).guid);
          this.scan.splits = this.scan.splits.map((split) => {
            if (split.guid === (mailCreatedWithRights as MailsSearchFromBroadcast).guid) {
              split.lock = true;
            }
            return split;
          });
          this.iScanAPIService.saveSplit(this.scan.guid, this.scan.splits).subscribe();
        }
      }

      mailCreatedWithRights.objet = mailCreatedWithRights.objet
        ? mailCreatedWithRights.objet
        : this.translate.translate('courrier.mailWithoutObject');

      foundScanSplit.details = {
        title: this.translate.translate('global.mail'),
        description: mailCreatedWithRights.canViewMail
          ? mailCreatedWithRights.objet
          : this.translate.translate('iScan.error.noRightsToSeeTheDescription'),
        titleButton: mailCreatedWithRights.id.toString(),
      };
      resolve(true);
    });
  }

  public archiveLotButton(): void {
    this.confirmationService.confirm({
      message: this.translate.translate('iScan.information.areYouSureYouWantToArchiveThisLot'),
      key: 'confirmDialogDetailsScan',
      accept: () => {
        this.archiveLot();
      },
    });
  }

  public archiveLot(): void {
    this.spinner.show();
    this.iScanAPIService.saveSplit(this.scan.guid, this.scan.splits).subscribe({
      next: () => {
        this.iCourrierScanService.updateStatusScan({ lotGuids: [this.scan.guid], status: 'Completed' }).subscribe({
          next: () => {
            this.spinner.hide();
            this.toastr.success(this.translate.translate('iScan.success.scanWasSuccessfullyCompleted', { scanLabel: this.scan.name }));
            this.router.navigateByUrl('private/ic/home-scans');
          },
          error: (err) => {
            this.spinner.hide();
            console.error(err);
            this.toastr.error(this.translate.translate('iScan.error.errorWhileArchivingScan'));
          },
        });
      },
    });
  }
  public processAllButton(): void {
    this.openProcessAllModal = true;
  }

  public attachAllButton(): void {
    this.openAttachAllModal = true;
  }
  public closingProcessAllModal(
    data: null | {
      splits: ScanSplit[];
      displayedValues: MassEncodeDisplayedDatas[];
      formValue: { dateEntree: Date; dateDocument: Date; dateEcheance: Date; datePostale: Date; remarques: string };
    }
  ): void {
    this.openProcessAllModal = false;
    this.spinner.show();

    const listOfMailsIdsAndGuids: { mailId: number; splitGuid: string }[] = []; // mail en succès
    const listOfSplitsInError: string[] = []; // mail en erreur

    if (data) {
      // En premier lieu on va envoyer le save au backend iScan
      // on va déjà tout locker. On unlockera si besoin SI le back iCourrier pause soucis lors de l'enregistrement
      this.scan.splits.map((split) => (split.lock = true));

      this.iScanAPIService.saveSplit(this.scan.guid, this.scan.splits).subscribe({
        next: () => {
          const splits = data.splits;
          const displayedValues: MassEncodeDisplayedDatas[] = data.displayedValues;
          const formValues = data.formValue;

          const dataToSendToBackend = {
            scanLot: this.scan.guid,
            scanLotCompleted: false,
            splits: [],
          };
          displayedValues.forEach((value) => {
            const index = this.originScan.splits.findIndex((split) => split.guid === splits[value.splitIndex].guid);
            const metaData = this.originScan.splits[index]?.mainCode;

            dataToSendToBackend.splits.push({
              split: splits[value.splitIndex].guid,
              barCode: metaData,
              centreNumerisationId: value.scanningCenter ? this.listOfCenterNums.find((x) => x.codeQr === value.scanningCenter)?.id : null,
              destinataireContactId: value.recipientId ? value.recipientId : null,
              serviceProprietaireId: value.serviceId,
              typeEntrantSortant: 'E',
              natureId: value.natureId ? value.natureId : null,
              sourceId: value.sourceId ? value.sourceId : null,
              referenceRecommande: value.recommendedRef ? value.recommendedRef : null,
              remarques: formValues.remarques,
              dateEntree: moment(formValues.dateEntree).format('YYYY-MM-DD'),
              dateDocument: formValues.dateDocument ? moment(formValues.dateDocument).format('YYYY-MM-DD') : null,
              dateEcheance: formValues.dateEcheance ? moment(formValues.dateEcheance).format('YYYY-MM-DD') : null,
              datePostale: formValues.datePostale ? moment(formValues.datePostale).format('YYYY-MM-DD') : null,
              classementId: value.classificationCodeId ? value.classificationCodeId : null,
              fileDescription: splits[value.splitIndex].name,
            });
          });

          this.iCourrierScanService.aCompleterFromScan(dataToSendToBackend).subscribe({
            next: (mailsCreated) => {
              mailsCreated.forEach((mailCreated) => {
                // si mailcreated.mail est rempli => le mail est créé
                // Si mailcreated.mail est vide => le mail n'a pas pu étre créé
                if (mailCreated.mail?.id) {
                  listOfMailsIdsAndGuids.push({ mailId: mailCreated.mail.id, splitGuid: mailCreated.split });
                } else {
                  listOfSplitsInError.push(mailCreated.split);
                }
              });

              // Sécurité : si le backend ne renvoie pas d'entrée pour un split envoyé,
              // on le considère comme en erreur pour qu'il soit déverrouillé
              const respondedGuids = mailsCreated.map((m) => m.split);
              const missingGuids = dataToSendToBackend.splits
                .map((s) => s.split)
                .filter((guid) => !respondedGuids.includes(guid));

              if (missingGuids.length) {
                console.error('Splits sans réponse du backend :', missingGuids);
                missingGuids.forEach((guid) => listOfSplitsInError.push(guid));
              }

              // Une fois que tout est terminé, on va devoir vérifier si on a un split en erreur.
              if (listOfSplitsInError.length) {
                // S'il y a au moins UN split en erreur, on va d'abord unlock les scans
                listOfSplitsInError.forEach((splitGuid) => {
                  const splitToUnlock = this.scan.splits.find((split) => split.guid === splitGuid);
                  if (splitToUnlock) {
                    splitToUnlock.lock = false;
                  } else {
                    console.error('Split en erreur introuvable dans this.scan.splits :', splitGuid);
                  }
                });
                this.iScanAPIService.saveSplit(this.scan.guid, this.scan.splits).subscribe();

                // Puis on va utiliser la liste de courriers afin de les afficher sans reload
                const listOfIds = listOfMailsIdsAndGuids.map((data) => data.mailId);
                this.mailsService.searchMailsToAttach({ ids: listOfIds }).subscribe({
                  next: (mails) => {
                    const mailCreatedWithRightsBroadcast: MailsSearchFromBroadcast[] = mails.map((mail) => {
                      return {
                        id: mail.id,
                        objet: mail.objet,
                        canViewMail: mail.canViewMail,
                        messageId: 'create',
                        guid: listOfMailsIdsAndGuids.find((item) => item.mailId === mail.id).splitGuid,
                        scanLotCompleted: false, // on force a false parce s'il y a des scans en erreur alors le lot est FORCEMENT incomplet
                      };
                    });
                    mailCreatedWithRightsBroadcast.forEach((mail) => {
                      this.displayAndSaveScanDetails(mail, true);
                    });
                    this.spinner.hide();
                  },
                });
              } else {
                // Si tout va bien, on marque le lot comme complété, PUIS on retourne sur la liste
                this.iCourrierScanService.updateStatusScan({ lotGuids: [this.scan.guid], status: 'Completed' }).subscribe({
                  next: () => {
                    this.spinner.hide();
                    this.toastr.success(this.translate.translate('iScan.information.mailsWereSuccessfullyCreated'));
                    this.router.navigateByUrl('private/ic/home-scans');
                  },
                  error: (err) => {
                    this.spinner.hide();
                    console.error(err);
                    this.toastr.error(this.translate.translate('iScan.error.errorWhileArchivingScan'));
                  },
                });
              }
            },
            error: (err) => {
              console.error('Erreur aCompleterFromScan:', err);
              this.scan.splits = this.scan.splits.map((split) => {
                if (dataToSendToBackend.splits.find((dataForBackend) => dataForBackend.split === split.guid)) split.lock = false;
                return split;
              });
              this.iScanAPIService.saveSplit(this.scan.guid, this.scan.splits).subscribe({
                next: () => {
                  this.spinner.hide();
                  this.toastr.error(this.translate.translate('iScan.error.errorWhileProcessingScans'));
                },
                error: (saveErr) => {
                  console.error('Erreur lors du déverrouillage des splits après échec:', saveErr);
                  this.spinner.hide();
                  this.toastr.error(this.translate.translate('iScan.error.errorWhileProcessingScans'));
                },
              });
            },
          });
        },
        error: () => {
          console.error('iscan put error');
        },
      });
    } else this.spinner.hide();
  }
}
